import { useEffect, useState } from 'react';
import API from '../api';

const inp = (extra={}) => ({ width:'100%',padding:'10px 13px',border:'1.5px solid #E5E7EB',borderRadius:9,fontSize:'0.9rem',outline:'none',background:'#FAFAFA',boxSizing:'border-box',fontFamily:"'Golos Text',sans-serif",...extra });
const lbl = { display:'block',fontSize:'0.75rem',fontWeight:700,color:'#6B7280',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.05em' };

function Toast({ msg, type, onDone }) {
  useEffect(()=>{ const t=setTimeout(onDone,2800); return()=>clearTimeout(t); },[onDone]);
  const c = type==='success' ? { bg:'#F0FDF4',color:'#166534',border:'#BBF7D0' } : { bg:'#FEF2F2',color:'#991B1B',border:'#FECACA' };
  return <div style={{ position:'fixed',bottom:24,right:24,zIndex:9999,background:c.bg,color:c.color,border:`1px solid ${c.border}`,padding:'12px 20px',borderRadius:12,fontWeight:600,fontSize:'0.875rem',boxShadow:'0 4px 20px rgba(0,0,0,.1)' }}>{msg}</div>;
}

const fields = [
  { key:'phone',     icon:'📞', label:'Телефон',      placeholder:'+998 77 252-03-30', hint:'Показывается в шапке и разделе контактов' },
  { key:'telegram',  icon:'✈️', label:'Telegram',     placeholder:'Master_clean_pro',  hint:'Username без @ — ссылка t.me/username' },
  { key:'instagram', icon:'📸', label:'Instagram',    placeholder:'master.cleanpro',   hint:'Username без @ — ссылка instagram.com/username' },
  { key:'city',      icon:'📍', label:'Город / Адрес',placeholder:'Фергана, Узбекистан',hint:'Отображается в разделе контактов' },
  { key:'hours',     icon:'🕐', label:'Режим работы', placeholder:'Ежедневно, 8:00 — 21:00', hint:'Отображается в контактах и FAB-кнопке' },
];

export default function AdminContacts() {
  const [form, setForm] = useState({ phone:'',telegram:'',instagram:'',city:'',hours:'' });
  const [toast, setToast] = useState(null);
  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  useEffect(()=>{ API.get('/contacts').then(r=>setForm(r.data)).catch(()=>{}); },[]);

  const save = async () => {
    try { await API.put('/admin/contacts',form); setToast({ msg:'✓ Контакты сохранены',type:'success' }); }
    catch { setToast({ msg:'Ошибка сохранения',type:'error' }); }
  };

  return (
    <div>
      {toast && <Toast msg={toast.msg} type={toast.type} onDone={()=>setToast(null)}/>}

      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontFamily:"'Unbounded',sans-serif",fontWeight:800,fontSize:'1.4rem',color:'#06101e',margin:'0 0 4px' }}>Контакты</h1>
        <p style={{ color:'#9CA3AF',fontSize:'0.875rem',margin:0 }}>Данные отображаются на сайте</p>
      </div>

      <div style={{ background:'#fff',borderRadius:16,padding:'24px',boxShadow:'0 1px 8px rgba(0,0,0,.06)',border:'1px solid #F0F0F0',maxWidth:580 }}>
        <div style={{ display:'grid',gap:18,marginBottom:24 }}>
          {fields.map(f=>(
            <div key={f.key}>
              <label style={lbl}>{f.icon} {f.label}</label>
              <input value={form[f.key]||''} onChange={e=>set(f.key,e.target.value)} placeholder={f.placeholder} style={inp()} onFocus={e=>e.target.style.borderColor='#00C2B8'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
              <div style={{ fontSize:'0.72rem',color:'#D1D5DB',marginTop:4 }}>{f.hint}</div>
            </div>
          ))}
        </div>
        <button onClick={save} style={{ padding:'12px 28px',background:'#00C2B8',color:'#06101e',border:'none',borderRadius:10,fontFamily:"'Unbounded',sans-serif",fontWeight:700,fontSize:'0.85rem',cursor:'pointer',boxShadow:'0 4px 14px rgba(0,194,184,.3)' }}>Сохранить изменения</button>
      </div>
    </div>
  );
}
